import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthenticated, logoutUser, getUserId } from '../utils/auth';
import apiClient from '../api/apiClient';
import './../styles/navbar.css';

const Navbar = () => {
  const [userData, setUserData] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (isAuthenticated()) {
          const userId = getUserId();
          const response = await apiClient.get(`/api/users/v1/${userId}`);
          const user_data = response.data;
          setUserData(user_data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchUserData();
  }, []);

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        {isAuthenticated() ? (
          <Link to="/dashboard" onClick={closeMenu}>Print Record News</Link>
        ) : (
          <Link to="/" onClick={closeMenu}>Print Record News</Link>
        )}
      </div>

      <button 
        className="navbar-toggle" 
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation"
      >
        {menuOpen ? '✕' : '☰'}
      </button>
      
      <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        {isAuthenticated() ? (
          <div className="user-nav-section">
            {userData && (
              <Link to="/dashboard" className="user-profile-link" onClick={closeMenu}>
                👤 {userData.first_name}
              </Link>
            )}
            <Link to="/dashboard" onClick={closeMenu}>Dashboard</Link>
            <button onClick={() => { handleLogout(); closeMenu(); }} className="logout-button">
              Sign Out
            </button>
          </div>
        ) : (
          <>
            <Link to="/" onClick={closeMenu}>Home</Link>
            <Link to="/about" onClick={closeMenu}>About</Link>
            <Link to="/contact" onClick={closeMenu}>Contact</Link>
            <Link to="/login" onClick={closeMenu} className="btn-primary" style={{ padding: '8px 20px', borderRadius: '6px' }}>Login</Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
